export default {
  'component.tagSelect.expand': 'Expandir',
  'component.tagSelect.collapse': 'Collapsar',
  'component.tagSelect.all': 'Todos',

  'component.notifications.operationCompleted': 'Operación completada',
  'component.notifications.successfully': 'satisfactoriamente',
  'component.notifications.operationRejected': 'Operación rechazada',
  'component.notifications.andUnderObservation': 'y en observación',
  'component.notifications.completeInformation': 'Completar información',
  'component.notifications.attachDocument': 'Adjuntar documento',
  'component.notifications.confirmDelete': '¿Seguro de querer eliminar este elemento?',
  'component.notifications.confirmReject': 'Motivo del rechazo',
  'component.notifications.confirmApprove': 'Observaciones aprobación',

  'component.filters.SearchInput.placeholder': 'Filtra escribiendo una palabra',
  'component.results': 'resultados',
  'component.errorBoundary.message': 'Something went wrong.',
  'component.errorBoundary.title': 'Oops! Algo salió mal',
  'component.errorBoundary.subtitle':
    'Lo sentimos, se ha producido un error inesperado. Por favor, intenta refrescar la página.',
  'component.errorBoundary.refresh': 'Refrescar página',
  'component.remote.search.placeholder': 'Introduzca al menos un caracter para buscar',

  'component.user.profilePhoto': 'foto de perfil',
  'component.user.userProfilePhoto': 'Foto de perfil de usuario',
  'component.user.userProfile': 'Perfil de usuario',
  'component.user.profile': 'perfil',
  'component.user.loadingProfilePhoto': 'Cargando foto de perfil',
  'component.user.nameProfilePhoto': 'Foto de perfil de {name}',
  'component.user.userIdProfilePhoto': 'Foto de perfil del usuario {id}',
  'component.user.nameProfile': 'Perfil de {name}',
  'component.user.nameInitials': 'Iniciales del Usuario',
  'component.user.defaultAvatar': 'Avatar del Usuario',
};
